import React from "react";
export default function ReportData(props) {
  let OTmarks = 0;
  for (var i = 0; i < 10; ++i) {
    if (parseInt(props.data[10 + i]) !== 0 && !isNaN(props.data[10 + i]))
      OTmarks += parseInt(props.data[10 + i]);
  }
  let TMarks = -50;
  for (let i = 0; i < 10; ++i) {
    if (parseInt(props.data[10 + i]) !== 0 && !isNaN(props.data[10 + i]))
      TMarks += 100;
  }
  let arr = [];
  for (let i = 0; i < 10; i++) {
    arr.push(DataFormat(i, props, TMarks, OTmarks));
  }
  arr.push(DataFormat(11, props, TMarks, OTmarks));
  return arr;
}
const DataFormat = (d, props, TMarks, OTmarks) => {
  return {
    Grade:
      d !== 11 ? (
        parseInt(props.data[10 + d]) === 0 || isNaN(props.data[10 + d]) ? (
          ""
        ) : (
          <span className="px-3">
            {props.dataHeader[10 + d] === "تدریس قرآن مجید"
              ? getGradeI(parseInt(props.data[10 + d]))
              : getGradeA(parseInt(props.data[10 + d]))}
          </span>
        )
      ) : (
        <span className="px-3">{getGradeA((100.0 * OTmarks) / TMarks)}</span>
      ),
    OMarks:
      d !== 11
        ? parseInt(props.data[10 + d]) === 0 || isNaN(props.data[10 + d])
          ? ""
          : parseInt(props.data[10 + d])
        : OTmarks,
    TMarks:
      d !== 11
        ? parseInt(props.data[10 + d]) === 0 || isNaN(props.data[10 + d])
          ? ""
          : props.dataHeader[10 + d] === "تدریس قرآن مجید"
          ? 50
          : 100
        : TMarks,
    Subject:
      d !== 11
        ? parseInt(props.data[10 + d]) === 0 || isNaN(props.data[10 + d])
          ? ""
          : props.dataHeader[10 + d]
        : "",
    SrNo:
      d !== 11
        ? d + 1 === 8
          ? "*" + (d + 1)
          : d + 1 === 9
          ? "**" + (d + 1)
          : d + 1 === 10
          ? "**" + (d + 1)
          : d + 1
        : "مجموعی نتیجہ"
  };
};

let getGradeA = (marks) => {
  marks = Math.round(marks);
  let grade = "";
  if (marks >= 80) {
    grade = "+A";
  } else {
    if (marks >= 70 && marks <= 79) {
      grade = "A";
    } else {
      if (marks >= 60 && marks <= 69) {
        grade = "B";
      } else {
        if (marks >= 50 && marks <= 59) {
          grade = "C";
        } else {
          if (marks >= 40 && marks <= 49) {
            grade = "D";
          } else {
            if (marks >= 33 && marks <= 39) {
              grade = "E";
            } else {
              grade = "F";
            }
          }
        }
      }
    }
  }
  return grade;
};
let getGradeI = (marks) => {
  let grade = "";
  if (marks >= 40) {
    grade = "+A";
  } else {
    if (marks >= 35 && marks <= 39) {
      grade = "A";
    } else {
      if (marks >= 30 && marks <= 34) {
        grade = "B";
      } else {
        if (marks >= 25 && marks <= 29) {
          grade = "C";
        } else {
          if (marks >= 20 && marks <= 24) {
            grade = "D";
          } else {
            if (marks >= 16.5 && marks <= 19) {
              grade = "E";
            } else {
              grade = "F";
            }
          }
        }
      }
    }
  }
  return grade;
};
